import WallexService from './WallexService'

export default class CurrencyService extends WallexService {
    public static get allCurrencies() {
        let currencies: string[] = []
        const currencies_ccy = [
            'AUD',
            'JPY',
            'SGD',
            'BHD',
            'KES',
            'ZAR',
            'BGN',
            'KWD',
            'SEK',
            'CAD',
            'MXN',
            'CHF',
            'CNH',
            'CNY',
            'NZD',
            'THB',
            'HRK',
            'NOK',
            'TRY',
            'CZK',
            'OMR',
            'UGX',
            'DKK',
            'PLN',
            'GBP',
            'EUR',
            'QAR',
            'AED',
            'HKD',
            'RON',
            'USD',
            'HUF',
            'RUB',
            'ILS',
            'SAR',
            'MYR',
        ]

        const currencies_doku = ['IDR']
        const currencies_dbs_sg = ['USD', 'EUR', 'GBP', 'SGD', 'HKD', 'JPY', 'AUD', 'CAD', 'NZD', 'NOK', 'SEK', 'CHF', 'CNH', 'CNY']
        const currencies_dbs_hk = ['HKD', 'EUR', 'USD', 'CNH']
        const currencies_asahi = ['VND', 'PHP', 'MYR']
        currencies = currencies.concat(currencies_ccy, currencies_doku, currencies_dbs_sg, currencies_dbs_hk, currencies_asahi)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        currencies = [...new Set(currencies)].sort()
        currencies = currencies.filter((value) => !this.mostUsedCurrencies.includes(value))
        return currencies
    }

    public static mostUsedCurrencies = ['SGD', 'USD', 'EUR', 'GBP', 'IDR', 'HKD', 'VND', 'PHP', 'MYR']
}
